<mat-form-field class="mr-4 mt-2 w-25 float-right">
    <mat-label>{{translate.getLng('COVER_PHOTO')}}</mat-label>
    <ngx-mat-file-input type="file" (change)="handlefileInput($event.target.files)"
        accept="{{global.allowedImageType}}">
    </ngx-mat-file-input>
    <mat-icon class="sen-active-color sen-cursor-pointer" matSuffix>attach_file</mat-icon>
    <mat-hint align="end">{{translate.getLng('FILES')}}</mat-hint>
</mat-form-field>
<ngx-treeview class="m-3 sen-fs12" [config]="config" [items]="items" (selectedChange)="onSelectionChange($event)">
</ngx-treeview>
<!--<a href="https://app.bundesnetzagentur.de/pv-meldeportal/" target="_blank" class="m-5 w-auto"
    mat-raised-button>{{translate.getLng('PV')}}</a>-->